import React from "react";
import { CircleLoader } from "react-spinners";

function CircleSpinner() {
  return <CircleLoader size="50px" />;
}

export default CircleSpinner;
